/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Request to complete the micro-deposit verification workflow.
 */
export type CompleteMicroDeposits = {
  /**
   * Two positive integers, in cents, equal to the values of the micro-deposits sent to the bank account.
   */
  amounts: Array<number>;
};

/** @internal */
export const CompleteMicroDeposits$inboundSchema: z.ZodType<
  CompleteMicroDeposits,
  z.ZodTypeDef,
  unknown
> = z.object({
  amounts: z.array(z.number().int()),
});
/** @internal */
export type CompleteMicroDeposits$Outbound = {
  amounts: Array<number>;
};

/** @internal */
export const CompleteMicroDeposits$outboundSchema: z.ZodType<
  CompleteMicroDeposits$Outbound,
  z.ZodTypeDef,
  CompleteMicroDeposits
> = z.object({
  amounts: z.array(z.number().int()),
});

export function completeMicroDepositsToJSON(
  completeMicroDeposits: CompleteMicroDeposits,
): string {
  return JSON.stringify(
    CompleteMicroDeposits$outboundSchema.parse(completeMicroDeposits),
  );
}
export function completeMicroDepositsFromJSON(
  jsonString: string,
): SafeParseResult<CompleteMicroDeposits, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CompleteMicroDeposits$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CompleteMicroDeposits' from JSON`,
  );
}
